import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { oauth2 as SMART } from "fhirclient";

function useQueryParams() {
  return new URLSearchParams(useLocation().search);
}

function Launcher() {
  const queryParams = useQueryParams();

  useEffect(() => {
    const iss = queryParams.get("iss");
    const launch = queryParams.get("launch");

    if (!iss || !launch) {
      console.error(
        "Missing SMART EHR launch queryparams. This app should be run using SMART provider-launch sandbox."
      );
      return;
    }

    SMART.authorize({
      clientId: process.env.REACT_APP_EPIC_CLIENT_ID,
      scope: process.env.REACT_APP_LAUNCH_SCOPE,
      redirectUri: "./auth",
      completeInTarget: true,
      iss,
      launch,
    });
  });

  return <h1>Launching SMART-on-FHIR flow...</h1>;
}

export default Launcher;
